import WalletConnectProvider from "@walletconnect/web3-provider";
import Web3 from "web3"


const provider = new WalletConnectProvider({
  infuraId: process.env.INFURA_ID
});

const Wallet = {
  address: '',
  async connect(wallet, src='body') {
    let accounts = [];
    // Initial Load
    if (src == 'init' && window.web3) {
      try {
        window.web3 = new Web3(window.ethereum);
        accounts = await window.web3.eth.getAccounts();
        if (accounts.length < 1) {
          return;
        }
      }catch(e) { 
        console.log(e);
      }

    } else {
      try {
        if (wallet === 'walletConnect') {
          await provider.enable();
          window.web3 = new Web3(provider);
          accounts = await window.web3.eth.getAccounts();
        } 
        else if(wallet === 'metamask' || window.ethereum) {
          await window.ethereum.request({ method: 'eth_requestAccounts' });
          window.web3 = new Web3(window.ethereum);
          accounts = await window.web3.eth.getAccounts();
        }        
      } catch(e) { 
        console.log(e);
      }
    }
    // Compile Wallet    
    this.address = window.web3.utils.toChecksumAddress(accounts[0]);
    let balance = await window.web3.eth.getBalance(this.address);
    return { address: this.address, balance: balance };
  },
  async disconnected() {
    await provider.disconnect()
    await provider.on("disconnect");
  }
}
export default Wallet;
